// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"ZP-z","inlineTitle":"_P-z","sponsoredAdsWrapper":"aQ-z","marketplaceRecosWrapper":"bQ-z"};